import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ProductInfoTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary
}));
